import { useDraggable } from "@dnd-kit/core";
import { useState } from "react";
import { RenderWhen } from "../../../../../../components";

import { AddIcon, DragAndDropIcon } from "../icons";
import styles from "./data-blocks.module.scss";

export type DataBlockType = {
  id: string;
  title: string;
  note?: string;
  description: string;
  onAddClick?: () => void;
};

type Props = DataBlockType;

const DataBlock = ({ id, title, note, description, onAddClick }: Props) => {
  const [isExpandend, setIsExpanded] = useState(false);
  const { attributes, listeners, setNodeRef } = useDraggable({
    id
  });

  const toggleExpand = () => {
    setIsExpanded(prev => !prev);
  };

  return (
    <div
      ref={setNodeRef}
      className={styles.container}
      style={{ cursor: "default" }}
      {...listeners}
      {...attributes}
    >
      <div id={`draggable-header-block-${id}`} className={styles.content}>
        <div className={styles.info}>
          <span
            data-testid={`${id}-block-title`}
            className={styles.title}
            onClick={toggleExpand}
          >
            {title}
          </span>
          <RenderWhen condition={Boolean(note)}>
            <span
              id={`draggable-header-subtitle-${id}`}
              className={styles.subtitle}
            >
              {note}
            </span>
          </RenderWhen>
        </div>
        <div className={styles.icons}>
          <AddIcon
            data-testid={`add-${id}-block-button`}
            onClick={onAddClick}
          />
          <DragAndDropIcon id={`draggable-header-button-${id}`} />
        </div>
      </div>
      <RenderWhen condition={isExpandend}>
        <span className={styles.description}>{description}</span>
      </RenderWhen>
    </div>
  );
};

export default DataBlock;
